import React from "react";
import { gql, QueryResult, useQuery } from "@apollo/client";

import { titleize } from "util/strings";
import SquarefootRecommendedListingCard from "components/cards/SquarefootRecommendedListingCard";
import {
  featuredListingsAdminPageQuery,
  featuredListingsAdminPageQueryVariables,
} from "components/SquarefootFeaturedListings/types/featuredListingsAdminPageQuery";

import cn from "classnames";
import styles from "./style.module.scss";

export const SQUAREFOOT_FEATURED_LISTINGS_QUERY = gql`
  query featuredListingsAdminPageQuery(
    $neighborhoods: String
    $live: Boolean
    $city: String
    $areaUUID: ID
    $areaUUIDs: [ID]
  ) {
    squarefootFeaturedListings(
      neighborhoods: $neighborhoods
      live: $live
      city: $city
      areaUUID: $areaUUID
      areaUUIDs: $areaUUIDs
    ) {
      id
      live
      title
      subtitle
      detail
      imageUrl
      mapPinContent
      insightPreview
      internalNote
      priority
      location
      badgeText
      linkUrl
      createdAt
      updatedAt
      lastEditedBy {
        displayName
      }
    }
  }
`;

type Props = {
  city?: string;
  neighborhoods?: string;
  areaUuid?: string;
  areaUuids?: string[];
  mode?: string;
};

export default function SquarefootFeaturedListings({
  city = "",
  neighborhoods = "",
  areaUuid,
  areaUuids,
  mode = "m",
}: Props) {
  const variables: featuredListingsAdminPageQueryVariables = {
    live: true,
    city: titleize(city || ""),
    neighborhoods,
    areaUUID: areaUuid,
    areaUUIDs: areaUuids,
  };
  const { data, loading, error }: QueryResult<featuredListingsAdminPageQuery> =
    useQuery(SQUAREFOOT_FEATURED_LISTINGS_QUERY, {
      variables,
    });
  const classNames = cn(styles.cards, { [styles.ice]: mode === "ice" });
  if (loading) return null;
  if (error) return null;
  if (!data) return null;
  const featuredListings = data?.squarefootFeaturedListings || [];
  return (
    <div className={classNames}>
      {featuredListings.map((listing) => (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a key={listing.id} href={listing.linkUrl!} target="_blank">
          <ul>
            <SquarefootRecommendedListingCard listing={listing} mode={mode} />
          </ul>
        </a>
      ))}
    </div>
  );
}
